import React from 'react';
import { connect } from 'react-redux';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Modal } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

import { obterFormandosPeloContrato } from '../actions/FormandoActions';
import { editarCamposContrato } from '../actions/ContratoActions';
import MapaServices from '../services/mapa';

class DetalhesDistribuicao extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showModal: false,
      tabelaItens: false,
      itensTabela: {
        header: [],
        body: [],
        total: []
      },
      selecionado: {},
      carregandoChangeEtapa: false
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  open () {
    this.setState({ showModal: true, itensTabela: { header: [], body: [], total: [] }, selecionado: this.props.selecionado }, () => {
      this.carregarInfoContrato(this.state.selecionado.id);
    });
  }

  close () {
    this.props.atualizarContrato({
      id: this.state.selecionado.id,
      distribuiuItens: this.state.selecionado.distribuiuItens
    });
    this.setState({ showModal: false });
  }

  async carregarInfoContrato(idContrato) {
    this.props.obterFormandosPeloContrato(idContrato).then(async () => {
      await this.criarHeaderTabelaItens();
      await this.ordenarPorTipo();
      await this.criarBodyTabelaItens();
      await this.removerConviteDoNome();
      await this.setState({tabelaItens: true});
    });
  }

  async criarHeaderTabelaItens () {
    let mapa = new MapaServices(),
      itens = this.state.selecionado.itens;

    await mapa.possuiAlphaPlay(this.state.selecionado.numOrcamento).then((response) => {
      if (response.length > 0) {
        this.setState({possuiAlphaPlay: `Este contrato possui Alpha-Play!`});
      } else {
        this.setState({possuiAlphaPlay: null});
      }
    }).catch(() => {toast.error("Não foi possível se comunicar com o Mapa de Vendas. Tente novamente!")});

    for (let i = 0; i < itens.length; i++) {
      let item = itens[i];

      if (item.observacao === "kit") {
        let auxItens = item.itens.split(";");
        for (let j = 0; j < auxItens.length; j++) {
          if (auxItens[j] !== "") {
            let nome = auxItens[j].substring(auxItens[j].split(" ")[0].length + 1)
            await this.checarHeadersTabelaItens(nome, item.id, item.quantidade * Number(auxItens[j].split(" ")[0]));
          }
        }
      } else {
        await this.checarHeadersTabelaItens(item.produto, item.id);
      }
    }
  }

  checarHeadersTabelaItens (nome, id) {
    let header = this.state.itensTabela.header,
      itemPesquisado = header.find((i) => {return nome === i.produto});

    id = Number(id);

    if (itemPesquisado === undefined || (itemPesquisado !== undefined && itemPesquisado.produto !== nome)) {
      header.push({produto: nome, ids: [id]});
    } else if (itemPesquisado.produto === nome) {
      header.forEach((item) => {
        if (item.produto === nome) {
          item.ids.push(id);
        }
      });
    }

    this.setState({itensTabela: {...this.state.itensTabela, header: header}});
  }

  criarBodyTabelaItens () {
    let { formandos } = this.props,
      { itens, turmas } = this.state.selecionado,
      { header } = this.state.itensTabela,
      indexFormandos = 0,
      total = [],
      totalLuxo = this.pegarIndexDaColunaTotal("TOTAL MIOLOS LUXO"),
      totalSemi = this.pegarIndexDaColunaTotal("TOTAL MIOLOS SEMI-LUXO"),
      totalSimples = this.pegarIndexDaColunaTotal("TOTAL MIOLOS SIMPLES");

    header.forEach(() => total.push(0));

    formandos.forEach((formando) => {
      formando.itensTabela = [];
      header.forEach(() => formando.itensTabela.push(0));
      formando.itens.map((itemFormando) => {
        let itemPesquisado = itens.find((i) => { return i.id === itemFormando.item }),
          itensEmArray = itemPesquisado.itens.split(";");
        itensEmArray.forEach((item) => {
          if (item !== "") {
            let itemQuantidade = Number(item.split(" ")[0]),
              itemProduto = item.substring(item.split(" ")[0].length + 1),
              indexMiolo = -1,
              qtdProduto = itemPesquisado.observacao === "kit" ? itemFormando.quantidade * itemQuantidade : itemFormando.quantidade;
            if (itemProduto.indexOf("Convite") !== -1) {
              if (itemProduto.indexOf("Semi-luxo") !== -1) {
                indexMiolo = totalSemi;
              } else if (itemProduto.indexOf("Luxo") !== -1) {
                indexMiolo = totalLuxo;
              } else if (itemProduto.indexOf("Simples") !== -1) {
                indexMiolo = totalSimples;
              }
              formando.itensTabela[indexMiolo] += qtdProduto;
              total[indexMiolo] += qtdProduto;
            }
            header.forEach((produto, j) => {
              if (produto.produto === itemProduto) {
                formando.itensTabela[j] += qtdProduto;
                total[j] += qtdProduto;
              }
            });
          }
        });
      });
    });  
    turmas.forEach((turma, i) => {
      turma.formandos = formandos.filter((f) => { return f.turma === turma.id });
      if (i > 0) {
        indexFormandos += turma.formandos.length;
      }
      turma.subtotal = [];
      turma.indexFormandos = indexFormandos;
      header.forEach(() => turma.subtotal.push(0));
      turma.formandos.forEach((formando) => {
        formando.itensTabela.forEach((item, i) => {
          turma.subtotal[i] += item;
        })
      })
    });

    this.setState({itensTabela: {...this.state.itensTabela, body: turmas, total: total}});
  }
  
  pegarIndexDaColunaTotal (coluna) {
    return this.state.itensTabela.header.map((i) => { return i.produto }).indexOf(coluna);
  }

  async removerConviteDoNome() {
    let { header } = this.state.itensTabela,
      novoHeader = [];

    for (let i = 0; i < header.length; i++) {
      let item = header[i];
      novoHeader.push(item);
      novoHeader[i].produto = novoHeader[i].produto.replace("Convite ", "");
      novoHeader[i].produto = novoHeader[i].produto.replace("com", "c/");
      novoHeader[i].produto = novoHeader[i].produto.replace("sem", "s/");
      novoHeader[i].produto = novoHeader[i].produto.replace("Aproveitamento", "Aprov.");
    }
    this.setState({itensTabela: {...this.state.itensTabela, header: novoHeader}});
  }

  async ordenarPorTipo () {
    let header = [...this.state.itensTabela.header],
      auxHeader = [],
      temLuxo = 0,
      temSemi = 0,
      temSimples = 0;

    header.forEach(item => {
      if (item.produto.includes("Luxo") && !item.produto.includes("Semi-")) {
        auxHeader.push(item);
        temLuxo++;
      }
    });

    temLuxo >= 2 ? auxHeader.push({produto: "TOTAL MIOLOS LUXO", ids: []}) : null;
    
    header.forEach(item => {
      if (item.produto.includes("Semi-")) {
        auxHeader.push(item);
        temSemi++;
      }
    });
    
    temSemi >= 2 ? auxHeader.push({produto: "TOTAL MIOLOS SEMI-LUXO", ids: []}) : null;

    header.forEach(item => {
      if (item.produto.includes("Simples")) {
        auxHeader.push(item);
        temSimples++;
      }
    });

    temSimples >= 2 ? auxHeader.push({produto: "TOTAL MIOLOS SIMPLES", ids: []}) : null;

    header.forEach(item => {
      if (!item.produto.includes("Luxo") && !item.produto.includes("Semi-") && !item.produto.includes("Simples")) {
        auxHeader.push(item);
      }
    });

    this.setState({itensTabela: { ...this.state.itensTabela, header: auxHeader }});
  }

  changeEtapa = (valor) => {
    this.setState({ carregandoChangeEtapa: true });
    this.props.editarCamposContrato( this.state.selecionado.id, { distribuiuItens: valor }).then(() => {
      this.setState({ selecionado: { ...this.state.selecionado, distribuiuItens: valor }, carregandoChangeEtapa: false});
    });
  }

  _renderCadeado () {
    let distribuiuItens = this.state.selecionado && this.state.selecionado.distribuiuItens === 1 ? true : false,
      novoValor = distribuiuItens ? 0 : 1;
    return <i disabled={this.state.carregandoChangeEtapa} className={this.state.carregandoChangeEtapa ? "fa fa-spinner fa-spin" : distribuiuItens ? "fa fa-lock" : "fa fa-unlock"} onClick={() => this.changeEtapa(novoValor)}/>;
  }

  render() {
    return (
      <Modal show={this.state.showModal} onHide={this.close} bsSize="large">
        <ToastContainer/>
        <Modal.Header closeButton>
          <Modal.Title>{this._renderCadeado()} | Planilha de quantidades do contrato {this.state.selecionado ? this.state.selecionado.numero : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            this.state.tabelaItens && this.state.selecionado.distribuiuItens ?
              <div style={{ marginBottom: 15, height: 500, overflow: "auto" }}>
                <table className="table" id="tabelaDistribuicao">
                  <thead>
                    <tr>
                      <th style={{textAlign:"center", border: "1px solid black", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 2}>Lista de quantidades - <span style={{textDecoration: "underline", textTransform: "uppercase"}}>Contrato {this.state.selecionado.numero}</span></th>
                    </tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    { this.state.possuiAlphaPlay !== null ? <tr><td colSpan={this.state.itensTabela.header.length + 2} style={{backgroundColor: "green", color: "white", textAlign: "center", fontSize: 16}}><strong>Alpha-Play: {this.state.possuiAlphaPlay}</strong></td></tr> : null }
                    <tr><td style={{border: "0 none"}}></td></tr>
                    <tr>
                      <th style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>X</th>
                      <th style={{border: "1px solid black", fontSize: 16}}>Formando</th>
                      { this.state.itensTabela.header.map((item, i) => <th key={i} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{item.produto}</th> ) }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.itensTabela.body.map((turma, i) => {
                        return [
                          <tr key={`th${i}`}>
                            <td></td>
                            <td style={{color: "red", textTransform: "uppercase", fontSize: 10, fontWeight: "bolder", textAlign: "center"}}>{turma.curso}</td>
                            <td colSpan={this.state.itensTabela.header.length}></td>
                          </tr>,
                          turma.formandos.map((formando, j) => ( 
                            <tr key={`tb${formando.id}`}>
                              <td style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{turma.indexFormandos + j + 1}</td>
                              <td style={{border: "1px solid black"}}>{formando.nome}</td>
                              { formando.itensTabela.map((item, k) => <td key={k} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{item}</td> ) }
                            </tr>
                          )),
                          <tr key={`tb${i}`}><td style={{border: "0 none"}}></td></tr>,
                          <tr key={`tc${i}`}>
                            <td style={{border: "1px solid black", borderRightColor: "transparent"}}></td>
                            <td style={{border: "1px solid black", borderLeftColor: "transparent", textAlign: "center"}}>Subtotal da turma de {turma.curso}</td>
                            { turma.subtotal.map((item, j) => <td key={j} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}>{item}</td> ) }       
                          </tr>,
                          <tr key={`td${i}`}><td style={{border: "0 none"}}></td></tr>
                        ]
                      })
                    }
                    <tr>
                      <td style={{border: "1px solid black", borderRightColor: "transparent"}}></td>
                      <td style={{border: "1px solid black", borderLeftColor: "transparent", textAlign: "center", fontSize: 16, fontWeight: 600}}>TOTAL</td>
                      { this.state.itensTabela.total.map((item, i) => <td key={i} style={{border: "1px solid black", textAlign: "center", fontSize: 16, fontWeight: 600}}>{item}</td> ) }
                    </tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    <tr><td style={{border: "0 none"}}></td></tr>
                    {/* INFORMAÇÕES PARA FATURAMENTO E ENTREGA */}
                    <tr><td colSpan={this.state.itensTabela.header.length + 2} style={{border: "1px solid black", textAlign: "center", fontSize: 16}}><strong>Informações para faturamento e entrega</strong></td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Responsável</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.nome}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>CPF</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.cpf}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>RG</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.rg}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>E-mail</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.email}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Celular</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.celular}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Endereço</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : `${this.state.selecionado.endereco.rua}, ${this.state.selecionado.endereco.complemento}`}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Bairro</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.bairro}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Cidade</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.cidade}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>Estado</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.estado}</td></tr>
                    <tr><td style={{border: "1px solid black", fontSize: 16}}>CEP</td><td style={{border: "1px solid black", textAlign: "left", fontSize: 16}} colSpan={this.state.itensTabela.header.length + 1}>{this.state.selecionado.endereco === undefined ? "Não preenchido" : this.state.selecionado.endereco.cep}</td></tr>
                  </tbody>
                </table>
                <ReactHTMLTableToExcel
                  className="btn btn-success pull-right"
                  table="tabelaDistribuicao"
                  filename={`Lista de quantidades - ${this.state.selecionado.numero}`}
                  sheet={`Lista de quantidades - ${this.state.selecionado.numero}`}
                  buttonText="Baixar"
                /> 
              </div>
            : <h4>Esta etapa ainda não foi finalizada</h4>
          }
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    formandos: state.formando.todos
  }
}

export default connect(mapStateToProps, { editarCamposContrato, obterFormandosPeloContrato }, null, { forwardRef: true }) (DetalhesDistribuicao);


// WEBPACK FOOTER //
// ./src/components/DetalhesDistribuicao.js